import React, { useEffect, useState } from "react";
import { collection, doc, getDoc, getDocs, onSnapshot, orderBy, query, where } from "firebase/firestore";
import { db } from "../../firebase";
import { format } from "date-fns";
import { Button } from "@mui/material";
import ClientWidgetV2 from "../ClientWidgetV2";
import TitleComponentV2 from "../Misc/TitleComponentV2";
import ClientRowDetails from "../Misc/ClientRowDetails";
import { incrementDailyReads } from "../../logsComponents/incrementDailyReads";
import ClientCardsSkeleton from "../ClientCardsSkeleton";
import { getRehabByClient } from "../../api/rehabs";

function ClinicalAssessmentClient({
  viewMode,
  therapistFilter = null,
  rehabFilter = null,
  ...props
}) {
  const [clients, setClients] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [clientDisplayLimit, setClientDisplayLimit] = useState(12);

  function formatDate(timestamp) {
    if (!timestamp || !timestamp.seconds) return "";

    const milliseconds =
      timestamp.seconds * 1000 + timestamp.nanoseconds / 1000000;
    const date = new Date(milliseconds);

    if (isNaN(date)) return "";

    return format(date, "d MMMM yyyy"); // "d" pour le jour, "MMMM" pour le mois en texte, "yyyy" pour l'année
  }

  useEffect(() => {
    const q = query(
      collection(db, "clients"),
      where("clientStatus", "==", "Clinical Assessment"),
      orderBy("eta", "desc")
    );
    // const q = query(
    //   collection(db, "clients"),
    //   where("clientStatus", "==", "Clinical Assessment")
    // );
    const unsubscribe = onSnapshot(q, async (querySnapshot) => {
      let readCount = querySnapshot.size;
      let subReads = 0;
      const clientDataWithAlerts = await Promise.all(
        querySnapshot.docs.map(async (clientDoc) => {
          const clientData = clientDoc.data();

          // Récupérer les détails supplémentaires
          const preAdmissionAssessmentRef = doc(
            db,
            "preAdmissionAssessments",
            clientDoc.id
          );
          const preAdmissionAssessmentSnap = await getDoc(
            preAdmissionAssessmentRef
          );
          subReads += 1;
          const preAdmissionAssessmentData = preAdmissionAssessmentSnap.data();

          const alertsSnapshot = await getDocs(
            collection(clientDoc.ref, "alerts")
          );
          subReads += alertsSnapshot.size;
          const alerts = alertsSnapshot.docs.map((alertDoc) => alertDoc.data());

          return {
            ...clientData,
            alerts,
            id: clientDoc.id,
            flightDetailsContent:
              preAdmissionAssessmentData?.flightDetailsContent,
            flightDetails: preAdmissionAssessmentData?.flightDetails,
            paymentDetails: preAdmissionAssessmentData?.paymentDetails,
            eta: preAdmissionAssessmentData?.eta,
          };
        })
      );

      //AJOUT TRI

      clientDataWithAlerts.sort((a, b) => {
        const etaA = a.eta
          ? new Date(a.eta.seconds * 1000)
          : new Date(-8640000000000000); // Date très éloignée dans le passé pour 'a'
        const etaB = b.eta
          ? new Date(b.eta.seconds * 1000)
          : new Date(-8640000000000000); // Date très éloignée dans le passé pour 'b'

        return etaB - etaA;
      });

      

      // Coarse daily read counter (non-blocking)
      try { incrementDailyReads("clients_clinical_assessment", readCount + subReads); } catch {}

      setClients(clientDataWithAlerts);
      setIsLoading(false);
    });
    return () => unsubscribe();
  }, []);

  const filteredClients = clients.filter((client) => {
    const matchesTherapist =
      !therapistFilter || client.selectedTherapist === therapistFilter;
    const matchesRehab =
      !rehabFilter || getRehabByClient(client)?.id === rehabFilter;

    return matchesTherapist && matchesRehab;
  });

  return (
    <div>
      <div className="container-counter-tris">
        Total records: {filteredClients.length}
      </div>
      {isLoading ? (
        <ClientCardsSkeleton variant="v2" />
      ) : (
        <div
          className="client-widgets-global-container"
          style={{ paddingLeft: "15px" }}
        >
          {viewMode ? <TitleComponentV2 /> : ""}
          {filteredClients.slice(0, clientDisplayLimit).map((client) => {
            // props.view === "mobile" ? (
            if (props.view === "mobile") {
              return (
                <ClientWidgetV2
                  key={client.id}
                  clientStatus={client.clientStatus}
                  firstnameClient={client.firstName}
                  lastnameClient={client.lastName}
                  clientIdentifier={client.clientIdentifier}
                  arrivalDate={formatDate(client.dateOfAdmission)}
                  idd={formatDate(client.idd)}
                  ils={client.durationOfStay}
                  assignedTherapist={client.selectedTherapist}
                  roomNumber={client.roomNumber}
                  aka={client.nickname}
                  age={client.age}
                  profilePic={client.profilePicture}
                  docId={client.id}
                  rehabId={client.rehabId}
                  rehabCountry={client.rehabCountry}
                  rehabName={client.rehabName}
                  dob={client.dob}
                  alerts={client.alerts}
                  alertType3={client.AlertType3}
                  alertType1={client.AlertType1}
                  alertType2={client.AlertType2}
                  flightDetails={client.flightDetails}
                  paymentDetails={client.paymentDetails}
                  eta={formatDate(client.eta)}
                  flightDetailsContent={client.flightDetailsContent}
                  primaryAddiction={client.primaryAddiction}
                />
              );
            } else {
              // ) : (
              return viewMode ? (
                <ClientRowDetails
                  key={client.id}
                  clientStatus={client.clientStatus}
                  firstName={client.firstName}
                  lastName={client.lastName}
                  gender={client.gender} // Assurez-vous d'ajouter les props manquantes
                  nationality={client.nationality}
                  country={client.country}
                  primaryAddiction={client.primaryAddiction}
                  secondaryAddiction={client.secondaryAddiction}
                  inActiveRecovery={client.inActiveRecovery}
                  eta={formatDate(client.eta)}
                  googleReviewDone={client.googleReviewDone}
                  personalEmail={client.personalEmail}
                  admissionDate={formatDate(client.dateOfAdmission)}
                  durationOfStay={client.durationOfStay}
                  flight={client.flight}
                  paymentDetail={client.paymentDetail}
                  vipTransfer={client.vipTransfer}
                  passportStatus={client.passportStatus}
                  profilPicture={client.profilePicture}
                  aka={client.nickname}
                  idClient={client.id}
                  clientData={client}
                  idd={formatDate(client.idd)}
                  ils={client.durationOfStay}
                  roomNumber={client.roomNumber}
                  assignedTherapist={client.selectedTherapist}
                  arrivalDate={formatDate(client.dateOfAdmission)}
                  dob={client.dob}
                  projectedResidentialDischargeDate={formatDate(
                    client.projectedResidentialDischargeDate
                  )}
                  assignedSupportStaff={client.assignedSupportWorker}
                />
              ) : (
                <ClientWidgetV2
                  key={client.id}
                  clientStatus={client.clientStatus}
                  firstnameClient={client.firstName}
                  lastnameClient={client.lastName}
                  clientIdentifier={client.clientIdentifier}
                  arrivalDate={formatDate(client.dateOfAdmission)}
                  idd={formatDate(client.idd)}
                  ils={client.durationOfStay}
                  assignedTherapist={client.selectedTherapist}
                  roomNumber={client.roomNumber}
                  aka={client.nickname}
                  age={client.age}
                  profilePic={client.profilePicture}
                  docId={client.id}
                  rehabId={client.rehabId}
                  rehabCountry={client.rehabCountry}
                  rehabName={client.rehabName}
                  dob={client.dob}
                  alertType3={client.AlertType3}
                  alertType1={client.AlertType1}
                  alertType2={client.AlertType2}
                  alerts={client.alerts}
                  flightDetails={client.flightDetails}
                  paymentDetails={client.paymentDetails}
                  eta={formatDate(client.eta)}
                  flightDetailsContent={client.flightDetailsContent}
                  primaryAddiction={client.primaryAddiction}
                />
              );
            }
          })}
        </div>
      )}
      {!isLoading && filteredClients.length > clientDisplayLimit && (
        <div className="seemore-container">
          <Button
            onClick={() => setClientDisplayLimit(clientDisplayLimit + 12)}
          >
            See more
          </Button>
        </div>
      )}
    </div>
  );
}

export default ClinicalAssessmentClient;
